var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "", "md-align": "start" } },
    [
      _c(
        "md-theme",
        { attrs: { "md-name": "brown-white" } },
        [_c("breadcrumbs", { attrs: { section: "Reporting", nav: _vm.nav } })],
        1
      ),
      _c(
        "md-theme",
        { attrs: { "md-name": "blue" } },
        [_c("licensing-report-table")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-435c2649", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-435c2649","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/reporting/Licensing.vue
// module id = 1027
// module chunks = 0